
import {Channel} from "modules/subscribe/share-app/api/entity/Channel";
import {api} from "modules/subscribe/share-app/api";
import {SubscribeKey} from "modules/subscribe/share-app/api/entity/SubscribeKey";
import {PropType} from "vue/dist/vue";
import {GroupedChannels, Subscribe} from "modules/subscribe/share-app/api/entity/Subscribe";

export default {
    props: {
        subscribe: {
            type: Object as PropType<Subscribe>,
            require: true,
        },
        subscribeKey: {
            type: Object as PropType<SubscribeKey>,
            require: true,
        }
    },
    emits: ['close'],
    methods: {
        getSelectedChannelIds(): Array<string> {
            let channelIds = [];
            this.subscribe.subscribeChannels.email?.forEach((channel: Channel) => {
                if (channel.needToBeChecked === true) {
                    channelIds.push(channel.id);
                    this.emailsCount++;
                }
            });
            this.subscribe.subscribeChannels.telegram?.forEach((channel: Channel) => {
                if (channel.needToBeChecked === true) {
                    channelIds.push(channel.id);
                    this.telegramsCount++;
                }
            });

            return channelIds;
        },
        async save() {
            try {
                const selectedChannelsIds = this.getSelectedChannelIds();
                if (selectedChannelsIds.length === 0) {
                    this.error = 'Необходимо выбрать хотя бы один вид оповещения.'
                    return;
                }
                this.loading = true;
                const resp = await api.subscribe(this.subscribeKey, selectedChannelsIds);
                if (resp.status === 'error') {
                    this.error = 'Не удалось подписаться'
                } else {
                    this.$emit('close', this.emailsCount, this.telegramsCount);
                }
            } catch (error) {
                console.log(error);
            } finally {
                this.loading = false;
            }
        }
    },
    async mounted() {
    },
    data() {
        return {
            error: null,
            emailsCount: 0,
            telegramsCount: 0,
            loading: false
        }
    }
};
